import { ContactName, ProviderPrescriberType } from '@uplift/types';
import { restClient } from '../../client';


export type PhysicianSupervisee = {
  id: string;
  collaborativePhysicianId: string;
  providerId: string;
  stateId: string;
  createdAt: string;
  archived: string | null;
  user: {
    id: string;
    firstName: string;
    lastName: string;
    email: string | null;
    phones: Array<{ name: ContactName.mobile | ContactName.work | ContactName.home; value: string }>;
  };
  prescriberType: ProviderPrescriberType | null;
  licenseStateIds: string[];
  currentCaseload: number;
  nextDueDate: string;
};


export const getProviderSupervisees = (providerId: string) => restClient.request<{ data: PhysicianSupervisee[] }>(
  `/api/v1/provider/${providerId}/supervisees`
);

export const getProviderSupervisee = (providerId: string, matchId: string) => restClient.request<{ data: PhysicianSupervisee }>(
  `/api/v1/provider/${providerId}/supervisees/${matchId}`
);


export type SupervisionMeetingMethod = 'video' | 'phone' | 'in_person';

export type SupervisionMeeting = {
  id: string;
  collaborativePhysicianId: string;
  superviseeId: string;
  stateId: string;
  meetingDate: string; // ISO date "YYYY-MM-DD"
  durationMinutes: number;
  method: SupervisionMeetingMethod;
  summary: string;
  createdAt: string; // ISO datetime
  submittedAt: string | null;
};


export type CreateSupervisionMeetingBody = {
  meetingDate: string; // "YYYY-MM-DD"
  durationMinutes: number;
  method: SupervisionMeetingMethod;
  summary: string;
};

export const getSupervisionMeetings = (providerId: string, matchId: string) =>
  restClient.request<{ data: SupervisionMeeting[] }>(
    `/api/v1/provider/${providerId}/supervisees/${matchId}/supervision_meetings`
  );

export const getSupervisionMeeting = (providerId: string, matchId: string, meetingId: string) =>
  restClient.request<{ data: SupervisionMeeting }>(
    `/api/v1/provider/${providerId}/supervisees/${matchId}/supervision_meetings/${meetingId}`
  );

export const createSupervisionMeeting = (
  providerId: string,
  matchId: string,
  body: CreateSupervisionMeetingBody
) =>
  restClient.request<{ data: SupervisionMeeting }>(
    `/api/v1/provider/${providerId}/supervisees/${matchId}/supervision_meetings`,
    {
      method: 'POST',
      data: {
        meeting_date: body.meetingDate,
        duration_minutes: body.durationMinutes,
        method: body.method,
        summary: body.summary,
      },
    }
  );
